module.exports = __webpack_public_path__ + "static/img/1619_phase_function_Paper_Points.5a9ed79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1619_phase_function_Paper_Points.png
// module id = 2Tsc
// module chunks = 0